<template>
    <!-- Login Box -->
    <v-card flat tile>
        <!-- Login / Sign up Tab -->
        <v-tabs
            grow
            hide-slider
            height="54"
        >
            <v-tab :ripple="false" to="/login">{{ $langs.Auth.login[$langs.lang] }}</v-tab>
            <v-tab :ripple="false" to="/register" class="primary lighten-1 white--text"
                >{{ $langs.Auth.signup[$langs.lang] }}</v-tab
            >
        </v-tabs>

        <!-- Login Form -->
        <v-form ref="form" @submit.prevent="submit()" class="py-6 px-8">
            <v-text-field
                class="rounded-sm"
                :label="$langs.Auth.email[$langs.lang]"
                type="email"
                v-model="account.email"
                autocomplete="username"
                :rules="[(v) => !!v || 'required']"
                required
            ></v-text-field>

            <v-text-field
                class="rounded-sm"
                :label="$langs.Auth.password[$langs.lang]"
                :type="showFieldPassword ? 'text' : 'password'"
                v-model="account.password"
                :append-icon="
                    showFieldPassword ? 'visibility' : 'visibility_off'
                "
                @click:append="showFieldPassword = !showFieldPassword"
                autocomplete="current-password"
                :rules="[(v) => !!v || 'required']"
                required
            ></v-text-field>

            <v-checkbox v-model="remember" label="ลงชื่อเข้าใช้ค้างไว้" hide-details dense :ripple="false">
            </v-checkbox>

            <v-btn
                block
                depressed
                large
                class="rounded-sm mt-3"
                type="submit"
                color="primary darken-1"
                :loading="isLoading"
                >{{ $langs.Auth.login[$langs.lang] }}</v-btn
            >

            <div class="mt-4 text-center">
                <router-link to="/resetpassword" class="text-subtitle-2 text-decoration-none"
                    >{{ $langs.Auth.forgetPassword[$langs.lang] }}</router-link
                >
            </div>
        </v-form>
    </v-card>
</template>

<script>
import api from "@/services/api";
import user from "@/services/user";
import { userConfig } from "@/services/constants";

export default {
    props: ["toHome"],
    data() {
        return {
            account: {
                email: "",
                password: "",
            },
            remember: false,
            showFieldPassword: false,
            isLoading: false,
        };
    },
    mounted() {
        this.remember = user.getConfig(userConfig.KEEP_SIGNIN) || this.remember;
        setTimeout(() => {
            if (this.$store.getters["isLogged"])
                this.$router.push("/");
        }, 50);
    },
    methods: {
        async submit() {
            if (!this.$refs.form.validate()) return;
            this.isLoading = true;
            const { success, msg } = await this.$store.dispatch({
                type: "Login",
                email: this.account.email,
                password: this.account.password,
                remember: this.remember
            });
            this.isLoading = false;
            if (success) {
                user.setConfig(userConfig.KEEP_SIGNIN, this.remember);
                api.makeAlert( "Login successful.", "primary" );
                if (this.toHome)
                    return this.$router.push("/");
                this.$router.go(-1);
            } else {
                api.makeAlert(msg, "error");
            }
        },
        makeAlert(color) {
            this.$store.dispatch({
                type: "MakeAlert",
                msg: new Date().toString(),
                color: color,
            });
        },
    },
    metaInfo() {
        return {
            title: "Login",
            titleTemplate: "%s · Marketpett",
            meta: [{ name: "robots", content: "noindex" }],
        };
    },
};
</script>

<style scoped lang="scss">
// .tab-active {
//     background: white;
//     &::before {
//         opacity: 0 !important;
//     }
// }
</style>